module.exports = __webpack_public_path__ + "static/media/storefront.94be0476.svg";